type SelectedNameProps = {
  name: string;
};

const SelectedName = ({ name }: SelectedNameProps) => {
  return <div className="custom-bg p-[8px] rounded">{name}</div>;
};

export default SelectedName;
